import Vue from 'vue';
import Vuex from 'vuex';
import UserStore from './module/UserStore';
import OldWekalaStore from './module/OldWekalaStore';
import BuilderStore from './module/BuilderStore';
import CopyWekalaStore from './module/CopyWekalaStore';
import DataValuesStore from './module/DataValuesStore';
import LookupStore from './module/LookupStore';
import ExternalTasdekStore from './module/ExternalTasdekStore';
Vue.use(Vuex);
export default new Vuex.Store({
  state: {},
  modules: {
    UserStore,
    OldWekalaStore,
    DataValuesStore,
    LookupStore,
    CopyWekalaStore,
    ExternalTasdekStore,
    BuilderStore
  },
  getters: {},
  actions: {},
});
